import React from "react";
import { Routes, Route } from "react-router-dom";
import OrdersList from "../generic/ordersList";
import ManualProcessingOrders from "./manualProcessingOrders";
import { App } from "/app/src/models";
export default function ManualProcessor({
  integrationId,
  app,
}: {
  integrationId: number;
  app: App;
}) {
  return (
    <Routes>
      <Route
        path="processes/:processId"
        element={<ManualProcessingOrders app={app} />}
      />
      <Route
        path="/"
        element={<OrdersList integrationId={integrationId} app={app} />}
      />
    </Routes>
  );
}
